import './flip-clock.js';

export function initFlipClock() {
  if (typeof window.initializeFlipClock === 'function') {
    window.initializeFlipClock();
  }
  return window.flipClock || null;
}

export function getFlipClockInstance() {
  return window.flipClock || null;
}
